export enum ErrorCode {
  NoContent = 13008001,
  ContentOnlyForLogin = 13008002,
  ContentOnlyForNotLogin = 13008003,
  ContentNeedSync = 13008004,
  ContentMapNotRight = 13008005,
}

export enum SELLER_STATUS {
  Active = 2,
  InActive = 5,
}

export enum ArticleDetailPageType {
  Normal = 0,
  Agreement = 1,
  Essay = 2,
}
